import React from "react"

import Layout from "../components/Layout"
import SEO from "@/components/SEO"
import { StaticImage } from "gatsby-plugin-image"
import { routes } from "../utils/routes"

type PageProps = {
  data: any
}

const RecognisingYourGift: React.FC<PageProps> = ({ data }) => (
  <Layout
    sectionOne={
      <>
        <div className="relative h-[67vh] md:min-h-[75vh]">
          <StaticImage
            src="../../static/images/2021/02/recognising-your-support.jpg"
            className="absolute inset-0 w-full h-full object-cover -z-50"
            alt="Recognising your Gift Header"
          />
          <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>

            <div className="container text-white h-[67vh] md:min-h-[75vh] flex items-center px-4">
              <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-10 md:translate-y-16 lg:translate-y-20">
                <div className="pb-4">
                  <h1
                    className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-bold normal-case tracking-normal font-gilroy"
                  >
                    Recognising Your Gift
                  </h1>
                  <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
                </div>
              </div>
            </div>
        </div>

        {/* Gold four-option bar below the fold */}
        <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
          <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
              <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Transformative Bursaries
              </a>
              <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                The South Wing
              </a>
              <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Sponsor a Paviour
              </a>
              <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
                Donate
              </a>
          </div>
        </div>
      </>
    }
  >
    <SEO title="Recognising your gift" />
    <div className="container py-14">
      <div className="flex justify-center">
        <div className="max-w-[700px]">
          <p className="mb-4 text-[24px] sm:text-[28px] md:text-[32px] font-gilroy font-bold leading-[0.9]">
            Every gift to the School will <span className="text-primary">benefit future generations of pupils</span> and is deeply appreciated. Donors will be <span className="text-primary">acknowledged</span> in a number of ways unless they wish to remain anonymous:
          </p>

          <div className="flex justify-center mt-6 lg:mt-8 overflow-x-auto">
            <img
              src="/images/donor%20page.png"
              className="block w-full max-w-4xl"
              style={{ width: "100%", height: "auto" }}
              alt="Donor Recognition Table"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default RecognisingYourGift
